module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OmGYMB/tc-custom/9781504080736.jpg?1731182522164",
      "alt": "This image is the cover for the book When the World Screamed"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("When the World Screamed\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Professor Challenger returns to test one of his theories by digging underground and poking the planet in this classic adventure story.")])]), _c('p', [_vm._v(" In "), _c('i', [_vm._v("The Lost World")]), _vm._v(", Professor Challenger and reporter Edward Malone found dinosaurs living in the Amazon. In "), _c('i', [_vm._v("The Poison Belt")]), _vm._v(", they witnessed chaos as Earth passed through a cloud of poison gas. Now, with the help of Peerless Jones, an expert in Artesian boring, they seek to test the professor’s Echinus theory . . . ")]), _vm._v(" Professor Challenger believes that Earth is a sentient being. Like the sea urchin, it is protected by an outer layer, unaware of what happens on its surface. Challenger wants to dig beneath Earth’s protective layer, its crust, and touch the creature inside to let it know humanity is here. But what the men find underground is quite surprising . . .\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Arthur Conan Doyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Arthur Conan Doyle (1859–1930) practiced medicine in the resort town of Southsea, England, and wrote stories while waiting for his patients to arrive. In 1886, he created two of the greatest fictional characters of all time: the detective Sherlock Holmes and his partner, Dr. Watson. Over the course of four novels and fifty-six short stories, Conan Doyle set a standard for crime fiction that has yet to be surpassed.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0